// @flow
import { connect } from 'react-redux';

import { Component } from 'components/newsletter/blocs/HtmlElementWrapper';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/newsletter/blocs/HtmlElementWrapper';

const mapStateToProps = (state: StateType): StateProps => ({
  clubName: state.settingsState.title,
});

export default connect(mapStateToProps)(Component);
